// extracted by mini-css-extract-plugin
export default {"crop":"crop_crop__kGup8","crop_ReactCrop":"crop_crop_ReactCrop__2-3+1"};